import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import { AppContext } from "contexts/AppContext";
import "./AuthPage.css";
import { Box } from "@mui/material";

const useStyles = createUseStyles({
  page: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    padding: "var(--auth-page-padding)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "@supports (height: 100dvh)": {
      minHeight: "100dvh",
    },
  },
  viewport: {
    position: "fixed",
    inset: 0,
    height: "100vh",
    minHeight: 0,
    boxSizing: "border-box",
    overflow: "hidden",
    "@supports (height: 100dvh)": {
      height: "100dvh",
    },
  },
});

const AuthPage = ({ children, contained = false }) => {
  const { brandData } = useContext(AppContext);
  const classes = useStyles();
  const imageUrl = brandData?.features?.loginImageURL
    ? brandData.features.loginImageURL.replace("cdn.upgrader.club", "cdn.upgraderadmin.dk")
    : undefined;

  return (
    <Box className={`auth-page ${classes.page}${contained ? ` ${classes.viewport}` : ""}`} sx={{ backgroundImage: { xs: 'none', sm: imageUrl ? `url("${imageUrl}")` : 'none' } }}>
      {children}
    </Box>
  );
};

export default AuthPage;
